import { render, staticRenderFns } from "./TileComment.vue?vue&type=template&id=305e01dc&"
import script from "./TileComment.vue?vue&type=script&lang=js&"
export * from "./TileComment.vue?vue&type=script&lang=js&"
import style0 from "./TileComment.vue?vue&type=style&index=0&id=305e01dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VHover,VIcon,VSpacer,VTooltip})
